import React, { useEffect, useState } from "react";
import { getBlogs_req } from "../api/api";
import Head from "next/head";
import Banner from "../components/banner";
import { useIntl } from "react-intl";
import { useRouter } from "next/router";
import nardiImg from "../assets/images/nardi.jpg";
import cheesImg from "../assets/images/chees.jpg";

import { useSelector } from "react-redux";

const Blog = () => {
  const router = useRouter();
  const intl = useIntl();
  const locale = useSelector((state) => state.global.locale);
  console.log(locale);
  const [blogData, setBlogData] = useState(null);
  const getBlog = async () => {
    const response = await getBlogs_req();
    console.log("Response", response);
    setBlogData(response.data);
  };

  const goInnerPage = (id) => {
    router.push(`/blog/${id}`);
  };

  useEffect(() => {
    getBlog();
  }, [locale]);
  const addText = (data) => {
    return { __html: data };
  };
  return (
    <>
      <Head>
        <title></title>
        <meta name="description" />
      </Head>
      <div className="blog">
        <Banner
          title={intl.messages.blog}
          currentPage={intl.messages.blog}
        />

        <div className="wrapper">
          <div className="flex flex-wrap">
            {blogData?.posts?.map((item, i) => (
              <div
                className="blog-item"
                onClick={() => goInnerPage(item.id)}
                key={i}
              >
                {item.id === 108 && (
                  <div className="image">
                    <img
                      src={item.image}
                      alt=""
                    />
                  </div>
                )}
                {item.id === 109 && (
                  <div className="image">
                    <img
                      src={item.image}
                      alt=""
                    />
                  </div>
                )}
                {item.id === 104 && (
                  <div className="image">
                    <img
                      src={item.image}
                      alt=""
                    />
                  </div>
                )}
                {item.id === 103 && (
                  <div className="image">
                    <img
                      src={item.image}
                      alt=""
                    />
                  </div>
                )}
                {item.id === 102 && (
                  <div className="image">
                    <img
                      src={nardiImg.src}
                      alt=""
                    />
                  </div>
                )}
                {item.id === 101 && (
                  <div className="image">
                    <img
                      src={cheesImg.src}
                      alt=""
                    />
                  </div>
                )}

                <div className="info">
                  {/* <h6>{item.title}</h6> */}
                  {item.id === 109 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.content.slice(0, 249) + "...",
                      }}
                    />
                  )}
                  {item.id === 108 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.content.slice(0, 249) + "...",
                      }}
                    />
                  )}
                  {item.id === 104 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.content.slice(0, 249) + "...",
                      }}
                    />
                  )}
                  {item.id === 103 && locale !== 1 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.content.slice(205, 450) + "...",
                      }}
                    />
                  )}
                  {item.id === 103 && locale === 1 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.content.slice(206, 450) + "...",
                      }}
                    />
                  )}
                  {item.id === 101 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.content.slice(0, 249) + "...",
                      }}
                    />
                  )}
                  {item.id === 102 && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item?.content.slice(0, 249) + "...",
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
